const getAlphabet = () => {
    let i: number;
    return [...Array(26)].map(() => (++i).toString(36), (i = 9));
};

export default getAlphabet;
